// extracted by mini-css-extract-plugin
export default {"border":"student_border__GyV88","color":"student_color__Kr7OX"};